import { create } from "zustand";
import { produce } from "immer";

const defaultData = {
  isLoading: false,
  isWaiting: false,
  customersReport: [],
  summary: {
    customerTotal: 0,
    withPackage: 0,
    subscribers: 0,
    averageTicket: 0,
    totalSales: 0,
  },
  filter: {
    dateFrom: null,
    dateTo: null,
    hasPackage: "*",
    isSubscriber: "*",
    minAbsenceDays: "30",
    cpf: "",
    search: "",
  },
  sort: {
    sortBy: "name",
    sortOrder: "asc",
  },
  pagination: {
    page: 0,
    totalPages: 0,
    perPage: 50,
    totalDocuments: 0,
  },
};

export const useCustomersReport = create((set) => ({
  data: defaultData,
  actions: {
    setCustomersReport: (customers, pagination) =>
      set((state) =>
        produce(state, (draft) => {
          const page =
            typeof pagination === "number" ? pagination : pagination.page;

          draft.data.customersReport[page] = customers;
          draft.data.pagination = pagination;

          draft.data.isLoading = false;
          draft.data.isWaiting = false;
        })
      ),

    setSummary: (summary) =>
      set((state) =>
        produce(state, (draft) => {
          draft.data.summary = { ...state.data.summary, ...summary };
        })
      ),

    setFilter: (filterProps) =>
      set((state) =>
        produce(state, (draft) => {
          draft.data.filter = { ...state.data.filter, ...filterProps };
        })
      ),

    setSort: (sortProps) =>
      set((state) =>
        produce(state, (draft) => {
          draft.data.sort = { ...state.data.sort, ...sortProps };
        })
      ),

    setPaginationPage: (page) =>
      set((state) =>
        produce(state, (draft) => {
          draft.data.pagination.page = page;
        })
      ),

    setLoading: (status) =>
      set((state) =>
        produce(state, (draft) => {
          draft.data.isLoading = status;
          draft.data.isWaiting = status;
        })
      ),

    setWaiting: (status) =>
      set((state) =>
        produce(state, (draft) => {
          draft.data.isWaiting = status;
        })
      ),

    clearCustomersReport: () =>
      set((state) =>
        produce(state, (draft) => {
          draft.data.customersReport = [];
        })
      ),

    clear: () =>
      set((state) =>
        produce(state, (draft) => {
          draft.data = defaultData;
        })
      ),
  },
}));
